import type { AccountRecord } from "@/types";

/** Textile trade fields of a buyer, held as strings while a form is being filled in */
export interface BuyerTermsForm {
  city: string;
  credit_limit: string;
  credit_days: string;
  payment_terms: string;
  transporter: string;
  agent_id: string;
}

export const EMPTY_BUYER_TERMS: BuyerTermsForm = {
  city: "",
  credit_limit: "",
  credit_days: "",
  payment_terms: "",
  transporter: "",
  agent_id: "",
};

export const buyerTermsFrom = (a?: Partial<AccountRecord> | null): BuyerTermsForm => ({
  city: a?.city || "",
  credit_limit: a?.credit_limit !== null && a?.credit_limit !== undefined ? String(Number(a.credit_limit)) : "",
  credit_days: a?.credit_days !== null && a?.credit_days !== undefined ? String(a.credit_days) : "",
  payment_terms: a?.payment_terms || "",
  transporter: a?.transporter || "",
  agent_id: a?.agent_id || "",
});

/** API body for the trade fields: blank numbers and agent are sent as null so they clear */
export const buyerTermsPayload = (f: BuyerTermsForm) => ({
  city: f.city.trim(),
  credit_limit: f.credit_limit === "" ? null : Number(f.credit_limit),
  credit_days: f.credit_days === "" ? null : Math.round(Number(f.credit_days)),
  payment_terms: f.payment_terms.trim(),
  transporter: f.transporter.trim(),
  agent_id: f.agent_id || null,
});
